/* eslint-disable header/header */
export const name = "@azure/msal-react";
export const version = "1.5.4";



// WEBPACK FOOTER //
// ./ClientApp/components/common/msal/packageMetadata.ts